import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { normalizeSocialLink as n } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as m } from "../../utils/get-social-link-icon.mjs";
import s from "../../../components/store-image.mjs";
import { useStore as i } from "../../../store/index.mjs";
import { StoreImageEnum as d } from "../../../enums/store-image-enum.mjs";
const b = ({ profile: e, socialLinks: r }) => {
  const { locale: a } = i();
  return /* @__PURE__ */ o(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[520px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-12 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ t(
          s,
          {
            width: 500,
            height: 520,
            alt: e.sellerName,
            imageType: d.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ o("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ t(
            "h1",
            {
              id: "region-heading",
              lang: a,
              className: "mb-2 break-all text-center text-[40px] font-bold leading-[50px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ t(
            "span",
            {
              lang: a,
              className: "hyphens-auto mb-4 text-center text-lg font-normal text-[#FAFAFA]",
              children: e.bio
            }
          )
        ] }),
        !!r.length && /* @__PURE__ */ t("div", { className: "z-1 flex flex-wrap items-center justify-center gap-6", children: r.map((l) => /* @__PURE__ */ t(
          "a",
          {
            href: n(l),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            "aria-label": l.type,
            children: m(l.type, "fill-[#FAFAFA]")
          },
          l.type
        )) }),
        /* @__PURE__ */ t(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-full w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
};
export {
  b as ProfileNewYork
};
